import { Component, EventEmitter, Input, Output, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subject, merge } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { TableFilter } from './table-filter';

@Component({
  selector: 'mstar-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterComponent implements OnDestroy {

  @Input() isTableData = false;
  @Input() filterableArray;
  @Input() columnsToFilter: [];

  @Output() tableDataChange = new EventEmitter();

  // this format of input + output is shorthand to allow two-way binding
  @Output() outputArrayChange = new EventEmitter<any[]>();
  @Input() outputArray: any;

  // == STATE ============================================================

  filterText = '';

  input = new Subject();
  input$ = this.input.asObservable();

  filtered = new Subject<any[]>();
  filtered$ = this.filtered.asObservable();

  // == SIDE EFFECTS =====================================================

  onInput$ = this.input$.pipe(
    debounceTime(100),
    tap(() => this.filterEntries())
  );

  // == SUBSCRIPTION =====================================================

  subscriptions = merge(
    this.onInput$
  ).subscribe();

  // == LIFECYCLE ========================================================

  constructor() {
    this.onInput$.subscribe();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  //== HELPERS =========================================================================

  filterEntries() {
    if (this.filterableArray !== null && typeof this.filterableArray !== 'undefined' && this.filterableArray.length > 0) {
      const filteredData = TableFilter.filterAny(this.filterableArray, this.filterText.trim());
      this.filtered.next(filteredData);

      if (this.isTableData) {
        this.outputArray.data = filteredData;
        this.tableDataChange.emit();
      } else {
        this.outputArrayChange.emit(filteredData);
      }
    }
  }

}
